import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { SubscriptionService } from '../../features/subscription/subscription.service';

export const subscriptionGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const subscriptionService = inject(SubscriptionService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) return true;

  try {
    await subscriptionService.ensureLoaded();
  } catch {
    // Falha ao carregar status (rede, servidor) → permite navegação
    return true;
  }

  if (subscriptionService.isExpired()) {
    return router.createUrlTree(['/assinatura']);
  }

  return true;
};
